var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmittedByAuditee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_888_97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1632 17.4134H29.4337V16.018C29.4337 14.0643 27.8289 12.5293 25.7865 12.5293C23.744 12.5293 22.1392 14.0643 22.1392 16.018V17.4134H21.4098C20.6074 17.4134 19.9509 18.0414 19.9509 18.8089V25.7862C19.9509 26.5538 20.6074 27.1817 21.4098 27.1817H30.1632C30.9656 27.1817 31.6221 26.5538 31.6221 25.7862V18.8089C31.6221 18.0414 30.9656 17.4134 30.1632 17.4134ZM25.7865 13.855C27.0265 13.855 28.0478 14.8318 28.0478 16.018V17.4134H23.5252V16.018C23.5252 14.8318 24.5464 13.855 25.7865 13.855ZM30.1632 25.7862H21.4098V18.8089H30.1632V25.7862ZM25.7865 23.693C26.5889 23.693 27.2454 23.0651 27.2454 22.2976C27.2454 21.5301 26.5889 20.9021 25.7865 20.9021C24.9841 20.9021 24.3276 21.5301 24.3276 22.2976C24.3276 23.0651 24.9841 23.693 25.7865 23.693Z",
    fill: "#687FBF",
    stroke: "#687FBF",
    strokeWidth: 0.518243
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9698 32.3684C20.6259 33.2339 18.0908 33.4458 15.6358 32.9815C13.1807 32.5172 10.8982 31.3941 9.03228 29.7324C7.1664 28.0706 5.78745 25.9329 5.04297 23.5478C4.2985 21.1628 4.21652 18.6201 4.80583 16.1921C5.39513 13.764 6.63352 11.5419 8.38849 9.76342C10.1435 7.98498 12.349 6.71718 14.769 6.09568C17.189 5.47418 19.7325 5.52237 22.1272 6.2351",
    stroke: "#687FBF",
    strokeWidth: 2.24572,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5612 9.58452L23.2873 6.75488L21.1689 2.14489",
    stroke: "#687FBF",
    strokeWidth: 2.24572,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_888_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8198,
    height: 17.2748,
    fill: "white",
    transform: "translate(18.2001 10.7002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedByAuditee);
export default __webpack_public_path__ + "static/media/Submitted By Auditee.8d680f004cb97624175ed33b16feb1bf.svg";
export { ForwardRef as ReactComponent };